import classnames from "classnames";
import ControlButton from "components/ControlButton";
import PropTypes from "prop-types";
import React from "react";
//TODO capture playback state play in the saga

export default function PlayButton(props) {
  const playButtonClassName = classnames({
    "icon-Pause": props.playing,
    "icon-Play": !props.playing,
  });

  return (
    <ControlButton
      ariaLabel={props.playing ? "Pause" : "Play"}
      border={false}
      classNameModifiers={["icon", "play-button"]}
      data-playing={props.playing}
      key="play-button"
      onClick={props.handlePlayButtonClick}
    >
      <span className={playButtonClassName} />
    </ControlButton>
  );
}

PlayButton.propTypes = {
  handlePlayButtonClick: PropTypes.func.isRequired,
  playing: PropTypes.bool.isRequired,
};
